<template>
 <div class="ui centered grid">
    <div class="four wide column"></div>
    <div class="eight wide column">
       <h3>Help</h3>
       <h4>Understanding images and their relationships to an inventory item.</h4>
        There are 3 different type of relationships
        <h5>Identified Art</h5>
        Identified Art is one of the possible identification of the inventory item. There might be more than one possibilities. Therefor there are a certainty assigned to the Identified Art. <br>We recognise thee levels of certainty:
        <ul>
            <li>high (green)</li>
            <li>medium (orange)</li>
            <li>low (red)</li>
        </ul>
        
        <h5>Resembling Object</h5>
        Resembling Object is most likely not the inventory item but we assume that the original item looked similarly. For instance we know later copy of the original artwork or we have drawing that was created before the final painting.
        
        <h5>Related Item</h5>
        Any other object that we want to mention in relation to the inventory item. The relation can be thematic or related to author or any other type.
<br><br>
     <h4>Understanding concordances</h4>
     Concordances are relation between inventory items in different inventories. Inventaria Rudolphina project digitalised more than 10 different inventories that describes the same collection or subset of the collection. 
     Each item in one inventory might describe the same collection item. Connecting of such items is done through the concordances. However we cannot determine this relation for all items and also we cannot be always 100% sure about this connection.
     Because of this we introduce certainty of such connection. One inventory item can be connected to multiple items from different inventory because of this uncertainty. <br>
    There four level of certainty:
    <ul>
        <li>same as (blue) this level is dedicated to concordances between Prague 1621A and Prague 1621B inventories.</li>
            <li>high (green)</li>
            <li>medium (orange)</li>
            <li>low (red)</li>
        </ul>
       
    </div>
    <div class="four wide column"></div>
</div>


</template>

<script>
  
    export default {
        name: 'help',
        data() {
            return {
            }
        },
       
        components: {
         
        },
    }
</script>

<style scoped>
    P{
         text-align: justify;
    }
</style>



// WEBPACK FOOTER //
// src/router/help.vue